import { useTellescopeMutation } from "@tellescope/tanstack-query";

/**
 * Hook for updating organization records.
 * Uses TanStack Query mutation with automatic cache invalidation.
 */
export function useUpdateOrganization() {
  return useTellescopeMutation({
    model: "organizations",
    method: "updateOne",
    autoCacheUpdateStrategy: "invalidate",
  });
}
